// config.js
const config = {
    // API_BASE_URL: "http://localhost:5000/api", 
    API_BASE_URL: "https://troyschwab.com/api",
  };
  // Running on http with no domain ties http://207.246.124.25:5000
  // Running locally it was http://localhost:5000
  
  export default config;
